export default __webpack_public_path__ + "static/media/BlankAvatar.b6b46c6d.svg";